/** One icon language for player actions across the web and mobile wrappers. */
export default function PlayerActionIcon({ action, side }) {
  const artwork = {
    wave: <>
      <path d="M8 20.5c-2-2-3-4-3-6.5V12a1.5 1.5 0 0 1 3 0V8.5a1.5 1.5 0 0 1 3 0V6a1.5 1.5 0 0 1 3 0v2a1.5 1.5 0 0 1 3 0v2a1.5 1.5 0 0 1 3 0v5c0 3-1 5-3 6.5" />
      <path d="M8 20.5c2 1.5 7 1.5 9 1M8 11v4m3-6v6m3-7v7m3-5v5" />
      <path d="M3 5 5 3m14 0 2 2" />
    </>,
    kick: <>
      <path d="M6 5h7l1 6 4 3 7 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3l4-2L6 5Z" />
      <path d="m13 12-3 3m6-1-3 3M4 19h21M7 22v2m6-2v2m6-2v2" />
    </>,
    header: <>
      <circle cx="12" cy="12" r="4.5" />
      <path d="M8.5 17 4 22l5 3 5-5 5 4" />
      <path d="M16.5 10.5 19 8m-1 5 2-1" />
      <circle cx="24.5" cy="5.5" r="4" />
      <path d="m23 4 2-1 2 2-1 2h-3l-1-2 1-1Z" strokeWidth="1.1" />
    </>,
    shout: <>
      <circle cx="9" cy="8" r="3" />
      <path d="M4 21c0-4 2-7 5-7s5 3 5 7M12 11l3 1-3 1M17 8c2 2 2 6 0 8m3-11c3 3 3 11 0 14" />
    </>,
  };
  const badge = side && <>
    <circle cx="25.5" cy="25.5" r="5.5" fill="#1e293b" />
    {side === 'L'
      ? <path d="M24 22.5v5h3" strokeWidth="1.8" />
      : side === 'R'
        ? <path d="M24 27.5v-5h2a1.4 1.4 0 0 1 0 2.8h-2m1.5 0 2 2.2" strokeWidth="1.6" />
        : <path d="M27.5 23.5a3 3 0 1 0 0 4" strokeWidth="1.7" />}
  </>;
  return <svg aria-hidden="true" focusable="false" width="34" height="34" viewBox="0 0 32 32"
    fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    {artwork[action] || artwork.wave}
    {badge}
  </svg>;
}
